import { useState } from "react";
import { SendHorizontal, Paperclip } from "lucide-react";

const PromptBox = ({ loading, onSubmit }) => {
  const [prompt, setPrompt] = useState("");

  const handleSubmit = () => {
    if (!prompt.trim()) return;

    onSubmit(prompt);
    setPrompt("");
  };

  return (
    <div className="pb-[61px] px-1 pt-2 border-t">

      <div className="relative rounded-xl border border-gray-700">

        <textarea
          rows={1}
          value={prompt}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Ask AI to generate reports..."
          className="
           w-full
           min-h-[48px]
           max-h-32
           overflow-y-auto
           resize-none
           bg-transparent
           outline-none
           px-4
           py-4
           pr-24
           leading-6
           custom-scrollbar
           "
        />

        <div className="absolute top-1/2 -translate-y-1/2 right-3 flex items-center gap-2">

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="
              h-9
              w-9
              rounded-xl
              bg-gradient-to-r
              from-violet-500
              to-purple-500
              flex
              items-center
              justify-center
              hover:scale-105
              transition
            "
          >
            <SendHorizontal
              size={18}
              className="text-white"
            />
          </button>

        </div>

      </div>

    </div>
  );
};

export default PromptBox;